/** @format */

import "./App.css";
import About from "./components/About";
import Contacts from "./components/Contacts";
import Examples from "./components/Examples";
import Header from "./components/Header";

function App() {
  return (
    <>
      <Header />
      <About />
      <Examples />
      <Contacts/>
    </>
  );
}

export default App;
